import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './plugins/element.js'
import axios from 'axios'
// console.log("router",router)
// axios.defaults.withCredentials = true

// axios.defaults.headers.common['cookie'] = 'test_server_session=eyJpdiI6IjNVUG4zdVVVcUF4cnlhMjdNeUh6NWc9PSIsInZhbHVlIjoiZWpPcXlENnpMVHA1SjgyTTZna3ZSMGlibnYwaTFOeUZ5MVdZaC9pczFKYWNWS29XVEVpZDRNS1ZNQzduZnhNVlY4dXd3dEtWUXVGUmx4eVJzZkFnR1EwVXNWTWVaOG0yNjd4dE5YNUhJMWpJeCt1RUp4UE9YNlRPYWJOV3piV1QiLCJtYWMiOiIwNTZkNGMxNzIwZjA0MWU4MTNhNjU2MDQxODU5MmViZjFjODkwYjRhNjhmYTE4NTJlOWNlY2JiMjE3MzMwMmNmIiwidGFnIjoiIn0%3D'

import router from './router'

/* 请求拦截 */
// axios.interceptors.request.use(
//   config => {
//     // if (localStorage.getItem("token") != null) {
//       config.headers["Authorization"] = 'test_server_session=eyJpdiI6IjNVUG4zdVVVcUF4cnlhMjdNeUh6NWc9PSIsInZhbHVlIjoiZWpPcXlENnpMVHA1SjgyTTZna3ZSMGlibnYwaTFOeUZ5MVdZaC9pczFKYWNWS29XVEVpZDRNS1ZNQzduZnhNVlY4dXd3dEtWUXVGUmx4eVJzZkFnR1EwVXNWTWVaOG0yNjd4dE5YNUhJMWpJeCt1RUp4UE9YNlRPYWJOV3piV1QiLCJtYWMiOiIwNTZkNGMxNzIwZjA0MWU4MTNhNjU2MDQxODU5MmViZjFjODkwYjRhNjhmYTE4NTJlOWNlY2JiMjE3MzMwMmNmIiwidGFnIjoiIn0%3D'
//     // }

//     return config;
//   },
//   err => Promise.reject(err)
// );

import antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './assets/reset.css'
Vue.use(antd)

// 复制操作插件vue-clipboard2
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.config.productionTip = false

Vue.prototype.$http = axios
// 页面中可以通过 this.$http.excel_url 来获取配置在axios上的excel_url

// 百度富文本
// import '../static/Ueditor/ueditor.config.js'
// import '../static/Ueditor/ueditor.all.min.js'
// import '../static/Ueditor/lang/zh-cn/zh-cn.js'
// import '../static/Ueditor/ueditor.parse.min.js'
// import '../static/Ueditor/themes/default/css/ueditor.css'

// 引入VueUeditorWrap组件--百度富文本
// import VueUeditorWrap from 'vue-ueditor-wrap'; // ES6 Module
// Vue.component('vue-ueditor-wrap', VueUeditorWrap) // 注册组件

// 获取表格信息，全局方法
import {getTableInfo, getDateInfo, getBeforeDate} from "./plugins/tableInfo.js"
Vue.prototype.$getTableInfo = getTableInfo
Vue.prototype.$getThisDay = getDateInfo // 获取当天日期
Vue.prototype.$getBeforeDay = getBeforeDate // 获取当天日期

// 分页组件
import pagingCmp from './components/pagingCompont.vue'
Vue.component('pagingCompont',pagingCmp)
// 表格内容的显示内容组件
import tabNull from './components/tableNull.vue'
Vue.component('tableNull',tabNull)
// 日期范围选择组件（不带时间选择）
import dateRangePicker from './components/dateRangePicker.vue'
Vue.component('dateRangePicker',dateRangePicker)

// 所有的角色身份。这里并没有用到，只是放到这里当一个说明。
Vue.prototype.roleData = { // 这样子配，可以全局访问。应该不会在项目中用到，但是写在这里用来参考
	ROLE_SUPER_MANAGER : 1, // 超级管理员
	ROLE_OPERATORS_MANAGER : 2, // 运营管理
	ROLE_PUT_MANAGER : 3, // 投放管理
	ROLE_PUT_USER : 4, // 投手
	ROLE_OPERATORS_USER : 5, // 运营
	ROLE_PUT_OPERATOR : 6, // 投放运营
	ROLE_CREATIVE : 7, // 创意上传者
	ROLE_PUT_TMP : 8, // 投放新人
	ROLE_ASSISTANT : 9, // 投放助理
	ROLE_BAIDU_PUTER : 12, // 百度投放，可看百度单元统计和百度数据看板
	ROLE_DATA_DATE_LIMIT : 13, // 数据近15天
	ROLE_DATA_PERMIT_TOUTIAO : 14, // 数据-巨量
	ROLE_DATA_QUICK_APP : 16, // 数据-快应用
}


//全局初始值
window.$InitialValues = {
	report_money_limit:5  //回传最低金额默认值
};

// 如果是cdn引用MUI，无需import，使用window.MUI即可
import MUI from '@bytedance-ad/mui-vue2'
// 别忘记引入样式文件
import '@bytedance-ad/mui-vue2/dist/style.css'
Vue.use(MUI);

new Vue({
    router,
    render: h => h(App),
    beforeCreate(){
	    Vue.prototype.$bus = this  
    }
}).$mount('#app')
